module.exports = __webpack_public_path__ + "static/media/scene-type.5fcc5af8.svg";